module.exports = __webpack_public_path__ + "static/image1-b4a7b81520077920182ec581ee72662a.jpg";